import { V2ProductionCostGetProductionCostPostResponse } from '@maxtropy/device-customer-apis-v2';
import React, { FC } from 'react';
import styles from './index.module.scss';
import { keepFourOrLine } from '@/utils/utils';

export interface ICardContent {
  data?: V2ProductionCostGetProductionCostPostResponse;
}

const CardContent: FC<ICardContent> = props => {
  const { data } = props;
  return (
    <div className={styles.card_wrapper}>
      {/* 累计用量 */}
      <div className={styles.total}>
        <div className={styles.summary_label}>
          累计用量 <span>{data?.energyMediumName ? `-${data?.energyMediumName}` : ''}</span>
        </div>
        <div className={styles.detail}>
          <div className={styles.label}>总用能</div>
          <div className={styles.value}>{keepFourOrLine(data?.totalCost) + (data?.unitName ?? '-')}</div>
        </div>
      </div>
      {/* 产品用能 */}
      <div className={styles.product_energy}>
        <div className={styles.summary_label}>产品用能</div>
        <div className={styles.detail}>
          {(data?.costDetailList ?? []).map(item => (
            <div className={styles.each}>
              <div className={styles.label}>{item.showProductionName ?? '-'}</div>
              <div className={styles.value}>{keepFourOrLine(item.value) + (item.unitName ?? '')}</div>
            </div>
          ))}
        </div>
      </div>
      {/* 产量 */}
      <div className={styles.product_energy}>
        <div className={styles.summary_label}>产量</div>
        <div className={styles.detail}>
          {(data?.productionDetailList ?? []).map(item => (
            <div className={styles.each}>
              <div className={styles.label}>{item.showProductionName ?? '-'}</div>
              <div className={styles.value}>{keepFourOrLine(item.value) + (item.unitName ?? '')}</div>
            </div>
          ))}
        </div>
      </div>
      {/* 平均单耗 */}
      <div className={styles.product_energy}>
        <div className={styles.summary_label}>平均单耗</div>
        <div className={styles.detail}>
          {(data?.avgCostDetailList ?? []).map(item => (
            <div className={styles.each}>
              <div className={styles.label}>{item.showProductionName ?? '-'}</div>
              <div className={styles.value}>{keepFourOrLine(item.value) + (item.unitName ?? '')}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CardContent;
